import { careTypeParagraphCopy, careTypeTitleCopy } from "./shared"

const totalProviders = (totalCareHomeCount, totalHomeCareCount) =>
  totalCareHomeCount + totalHomeCareCount

export default ({
  locationName,
  totalHomeCareCount,
  totalCareHomeCount,
  regulatoryBody,
}) => [
  {
    question: `How many elderly care providers are there in ${locationName}?`,
    answer:
      totalProviders(totalCareHomeCount, totalHomeCareCount) === 1
        ? `There is only 1 care provider in ${locationName} who specialises in care for the elderly.`
        : `There are ${totalProviders(
            totalCareHomeCount,
            totalHomeCareCount,
          )} care providers in ${locationName} who specialise in care for the elderly, this includes ${totalCareHomeCount} care homes and ${totalHomeCareCount} home care agencies.`,
  },
  {
    question: careTypeTitleCopy("agnostic", locationName),
    answer: careTypeParagraphCopy("agnostic", locationName, regulatoryBody),
  },
]
